import React, { useState, createContext, useEffect } from 'react';
import userService from 'services/user';

export const CurrentUserContext = createContext({
    user: {},
    setUser: () => {}
} as UserContext);

export const CurrentUserProvider: React.FC<any> = props => {
    const [user, setUser] = useState<User>({
        name: '',
        type: '',
        loggedIn: false
    });

    useEffect(() => {
        getInfo();
    }, []);

    const getInfo = async () => {
        let infoRes = await userService.me();
        if (infoRes?.success && infoRes.data) {
            setUser({
                name: infoRes.data.name,
                loggedIn: true,
                type: infoRes.data.type
            });
        } else {
            setUser({
                ...user,
                loggedIn: false
            });
        }
    };

    return (
        <CurrentUserContext.Provider value={{ user, setUser }}>
            {props.children}
        </CurrentUserContext.Provider>
    );
};

export interface User {
    name?: string;
    loggedIn: boolean;
    type?: string;
}

interface UserContext {
    user?: User | undefined;
    setUser?: any;
}
